"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgNeedleFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M18.87 13.212c.942.943.942 1.886 0 2.828l-.708.708 1.414 1.414 1.415-1.414c.471-.472.942-.472 1.414 0 .471.471.471.942 0 1.414l-4.243 4.242c-.471.472-.943.472-1.414 0-.472-.47-.472-.942 0-1.414l1.414-1.414-1.414-1.414-.707.707c-.943.943-1.886.943-2.829 0-1.413-1.415-4.9-4.9-7.07-7.07-.943-.944-.943-1.887 0-2.83l.706-.707L2.81 4.247h2.83l2.624 2.601.707-.707c.943-.943 1.885-.943 2.828 0l7.071 7.071zm-9.897-1.41l1.414 1.414.707-.707c.472-.47.472-.943 0-1.414-.47-.472-.942-.472-1.414 0l-.707.707zm2.829 2.828l1.414 1.415.707-.708c.471-.47.471-.942 0-1.414-.472-.47-.943-.47-1.414 0l-.707.707z' }))); };
exports.default = SvgNeedleFilled;
//# sourceMappingURL=NeedleFilled.js.map